export const SUPPORTS_ARRAY_PROTOTYPE_FIND_INDEX = "findIndex" in Array.prototype;
